"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import Account from "../../api/account";
import { Link } from "react-router";
function invoiceStatus(invoice) {
  return /* @__PURE__ */ jsxs("span", { className: "load-detail__invoice-status-text", children: [
    "Status: ",
    invoice.status
  ] });
}
function invoiceTitle(props) {
  if (Account.currentSettings().display_load_reference_as_title) {
    return null;
  }
  if (props.load.load.source_system === "hubtran") {
    return /* @__PURE__ */ jsxs("div", { children: [
      "Editing Draft Load\xA0",
      /* @__PURE__ */ jsx("small", { children: /* @__PURE__ */ jsx(Link, { to: assignLoadsUrl(props), children: "Go back and select a load" }) })
    ] });
  }
  return /* @__PURE__ */ jsxs("span", { className: "load-detail__invoice-header-text", children: [
    "Load ",
    props.load.load.load_id
  ] });
}
function assignLoadsUrl(props) {
  return "/index-document-batches/" + props.batchId;
}
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ jsxs("div", { className: "load-detail__header", children: [
      /* @__PURE__ */ jsx("h3", { className: "load-detail__invoice-header", children: invoiceTitle(this.props) }),
      !Account.auditBillingEnabled() && /* @__PURE__ */ jsx("h3", { className: "load-detail__invoice-status", children: invoiceStatus(this.props.carrierInvoice) })
    ] });
  }
});
